import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import HotComicsSection from './components/HotComicsSection';
import FeaturedSection from './components/FeaturedSection';
import EditorPickSection from './components/EditorPickSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="WebSite" data={{
        name: '韩漫屋',
        url: 'http://pedionline.com/',
        description: '韩漫屋是免费韩漫与漫画大全的聚集地，提供海量在线漫画资源',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://pedionline.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="Organization" data={{
        name: '韩漫屋',
        url: 'http://pedionline.com/',
        description: '韩漫屋 - 免费韩漫,漫画大全,在线漫画,好看的韩国漫画',
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '韩漫屋首页 - 免费韩漫,漫画大全,在线漫画',
        url: 'http://pedionline.com/',
        description: '韩漫屋是免费韩漫与漫画大全的聚集地，提供海量在线漫画资源，并持续为您推荐好看的韩国漫画作品。',
        isPartOf: { '@type': 'WebSite', name: '韩漫屋', url: 'http://pedionline.com/' },
      }} />

      <Navbar />

      <main>
        <HeroSection />
        <HotComicsSection />
        <FeaturedSection />
        <EditorPickSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}